import { GEWERK } from './gemeinsam';
import { DataTable, EmptyState, type Spalte } from '../../muster';

/**
 * Die Gleichrangregeln — sie entscheiden INNERHALB eines Gewerks, wo der
 * Gewerkevorrang nichts zu sagen hat (Elt gegen Elt, Rlt gegen Rlt).
 */
export function Gleichrangregeln({ regeln }: { regeln: any[] }) {
  const spalten: Spalte<any>[] = [
    { schluessel: 'rang', titel: 'Rang', art: 'zahl', breite: '80px', wert: (r) => r.rang },
    {
      schluessel: 'gewerk', titel: 'Gewerk', breite: '130px',
      wert: (r) => GEWERK[r.gewerk] ?? r.gewerk,
    },
    {
      schluessel: 'regel', titel: 'Regel', immerSichtbar: true,
      wert: (r) => r.bezeichnung,
      inhalt: (r) => <span style={{ fontSize: 12 }}>{r.bezeichnung}</span>,
    },
    {
      schluessel: 'kriterium', titel: 'Kriterium',
      wert: (r) => r.kriterium,
      inhalt: (r) => (
        <span className="schwach" style={{ fontSize: 11 }}>{r.kriterium}</span>
      ),
    },
    {
      schluessel: 'herkunft', titel: 'Herkunft', breite: '150px',
      wert: (r) => r.herkunft,
      inhalt: (r) => <span className="schwach">{r.herkunft}</span>,
    },
  ];

  return (
    <DataTable
      name="Gleichrangregeln"
      beschreibung={'Der Gewerkevorrang entscheidet ZWISCHEN Gewerken. Bei gleichem '
        + 'Rang (Elt gegen Elt, Rlt gegen Rlt) hat er nichts zu sagen — diese Regeln '
        + 'entscheiden innerhalb eines Gewerks, nach Bauteilart, Systemtyp, '
        + 'Querschnitt, Achse oder freier Gegenrichtung.'}
      spalten={spalten}
      zeilen={regeln ?? []}
      schluessel={(r) => `${r.gewerk}-${r.bezeichnung}-${r.rang}`}
      sortierung={{ spalte: 'rang', richtung: 'auf' }}
      ausfuhr
      leer={(
        <EmptyState
          titel="Keine Gleichrangregel gepflegt."
          erklaerung={'Ohne sie bleibt jede Kollision innerhalb eines Gewerks eine '
            + 'Planungsentscheidung — die Ableitung kann nicht sagen, wer ausweicht.'}
        />
      )}
    />
  );
}
